import type { Person as PersonModel } from '@/adapters/catalogv1.g';

export function extractPerson(model: PersonModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.person_ref ?? '',
    name: model.name ?? '',
    displayName: model.display_name ?? '',
    firstName: model.first_name,
    lastName: model.last_name,
    middleName: model.middle_name,
    primaryEmail: model.primary_email?.address,
    alternateEmails: model.alternate_emails?.map((e) => e.address ?? '') ?? [],
    primaryPhone: model.primary_phone?.number,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPerson = ReturnType<typeof extractPerson>;
